import { Flex, Text, useLocalState, Checkbox } from "@huub-web/ui";
import type { FC } from "react";

import type { ViewingTip } from "../../../types";
import { containerStyle } from "./ViewingTipRow.css";

export type ViewingTipRowProps = {
  id: string;
  description: string;
  advice?: string;
  tips?: ViewingTip["tips"];
};

export const ViewingTipRow: FC<ViewingTipRowProps> = ({
  id,
  description,
  advice,
  tips,
}) => {
  const [checked, setChecked] = useLocalState<boolean | null>(
    `viewingTip.${id}`,
  );

  return (
    <Flex gap="s" align="flex-start" className={containerStyle}>
      <Flex shrink={false}>
        <Checkbox id={id} checked={checked ?? false} onChange={setChecked} />
      </Flex>
      <Flex direction="column" gap="s" align="flex-start" grow>
        <Flex direction="column" gap="xxs">
          <Text as="label" htmlFor={id}>
            {description}
          </Text>

          {advice && (
            <Text variant="bodyS" markdown color="currentColor50">
              {advice}
            </Text>
          )}
        </Flex>
        {tips?.map((tip) => (
          <ViewingTipRow
            key={tip.id}
            id={tip.id}
            description={tip.description}
            advice={tip.advice}
          />
        ))}
      </Flex>
    </Flex>
  );
};
